export function OutlineChevronUpIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.6849 5.8507L14.5149 8.6807L19.6349 13.8007C20.4149 14.5807 20.4149 15.8507 19.6349 16.6307C19.2449 17.0207 18.7349 17.2207 18.2249 17.2207C17.7149 17.2207 17.1949 17.0207 16.8049 16.6307L11.6849 11.5107L6.5649 16.6307C5.7849 17.4107 4.5149 17.4107 3.7349 16.6307C2.9549 15.8507 2.9549 14.5807 3.7349 13.8007L11.6849 5.8507Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
